// 固件版本管理
import http from "@/jslibs/axios/http";

// 列表
export const page = (data) => http.post("/web/firmwareManager/getFirmwareVersionList", data);

// 新增
export const add = (data) => http.post("/web/firmwareManager/addFirmware", data);

// 编辑
export const edit = (data) => http.post("/web/firmwareManager/editFirmwareVersion", data);

// 删除
export const del = (data) => http.post("/web/firmwareManager/deleteFirmwareVersion", data);

// 详情
export const detail = (data) => http.post("/web/firmwareManager/getFirmwareVersionDetail", data);

